import React from "react";

export default function LocationFinalCTASection({
  title,
  description,
  phone = "+91 7996 800 900",
  whatsappNumber = "917996800900",
}) {
  if (!title || !description) return null;

  return (
    <section className="relative overflow-hidden bg-[#06152f] py-14 sm:py-16 lg:py-20">
      <style>
        {`
          @keyframes ctaShine {
            0% { transform: translateX(-130%) rotate(16deg); }
            100% { transform: translateX(180%) rotate(16deg); }
          }

          @keyframes ctaFloat {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>

      <div className="pointer-events-none absolute left-[-180px] top-[-180px] h-[430px] w-[430px] rounded-full bg-[#f4d16b]/18 blur-3xl" />
      <div className="pointer-events-none absolute right-[-180px] bottom-[-180px] h-[460px] w-[460px] rounded-full bg-[#c89b2b]/16 blur-3xl" />

      <div
        className="pointer-events-none absolute top-0 h-full w-[34%] bg-gradient-to-r from-transparent via-white/12 to-transparent blur-md"
        style={{ animation: "ctaShine 5s ease-in-out infinite" }}
      />

      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-6 lg:px-10">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_auto] lg:gap-14">
          {/* LEFT CONTENT */}
          <div>
            <div className="mb-6 flex items-center gap-4">
              <span className="h-[2px] w-16 rounded-full bg-[#f2d36a]" />
              <span className="h-2.5 w-2.5 rotate-45 bg-[#f2d36a]" />
            </div>

            <h2 className="max-w-[760px] text-[30px] font-extrabold leading-tight tracking-[-0.04em] text-white sm:text-[42px] lg:text-[56px]">
              {title}
            </h2>

            <p className="mt-6 max-w-[850px] text-[16px] font-medium leading-8 text-white sm:text-[18px] lg:leading-9">
              {description}
            </p>
          </div>

          {/* RIGHT ACTION */}
          <div
            className="relative lg:min-w-[330px]"
            style={{ animation: "ctaFloat 6s ease-in-out infinite" }}
          >
            <div className="relative border-l-4 border-[#f2d36a] pl-6 sm:pl-7">
              <p className="text-[13px] font-extrabold uppercase tracking-[0.3em] text-[#f2d36a]">
                Call / WhatsApp
              </p>

              <a
                href={`tel:${phone.replace(/\s/g, "")}`}
                className="mt-3 block text-[26px] font-extrabold leading-tight text-white sm:text-[32px]"
              >
                {phone}
              </a>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row lg:flex-col">
                <a
                  href={`tel:${phone.replace(/\s/g, "")}`}
                  className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#C89B2B] to-[#F2D36A] px-7 py-4 text-[15px] font-extrabold text-[#06152f] shadow-[0_18px_38px_rgba(200,155,43,0.28)] transition hover:-translate-y-1"
                >
                  Call Now
                </a>

                <a
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-full border border-[#f2d36a]/70 px-7 py-4 text-[15px] font-extrabold text-white transition hover:-translate-y-1 hover:bg-white/10"
                >
                  WhatsApp Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}